import { AlertCircle } from 'lucide-react';
import { Button } from '../design-system/Button';
import { Text } from '../design-system/Text';

interface ErrorStateProps {
  onRetry: () => void;
}

export function ErrorState({ onRetry }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-8 py-16 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-50 text-red-500 dark:bg-red-900/30">
        <AlertCircle className="h-8 w-8" />
      </div>
      <Text variant="title" className="mt-4">Something went wrong</Text>
      <Text variant="body" color="secondary" className="mt-1">
        We couldn't load your challans. Please try again.
      </Text>
      <Button onClick={onRetry} className="mt-6">Retry</Button>
    </div>
  );
}
